import { Button } from "react-bootstrap";
import "@/styles/components/gitcha-not-available-modal.css";
import Modal from "react-bootstrap/Modal";
import { urlLinks } from "@/constants";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";

/**
 * GTCH-853. Shown when a market has moved to the Buyer Listing Service.
 *
 * Distinct from GitchaNotAvailableModal: that one means "we aren't here yet".
 * This one means "we're here, you can search, but want-listings are created on
 * the BLS and syndicated over". Searching and browsing are unaffected.
 *
 * The stated reason is licensing, per the PO: the MLS serving the market
 * licenses Want-Listing posting to its own members, which is why the limit is
 * on posting only and never on reading.
 *
 * `reason` follows the API: MARKET_RESTRICTED when a new want-listing is
 * refused, POLICY_LOCKED when an existing one can no longer be re-activated.
 */
const MarketRestrictedModal = (props) => {
  const { show, onHide, reason = "MARKET_RESTRICTED" } = props;

  const { isGitchaDefaultWebsite, mls } = useCurrentWebsite();
  const brand = isGitchaDefaultWebsite ? "Gitcha" : (mls || "").toUpperCase();

  const isReactivation = reason === "POLICY_LOCKED";

  const handleLearnMoreNavigation = () => {
    window.open(urlLinks.gitchaMLSIntegration, "_blank");
  };

  const handleContactUsNavigation = () => {
    window.open(urlLinks.contactUs, "_blank");
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="market-restricted-modal-title"
      centered
      show={show}
      dialogClassName="modal-wrapper"
      backdrop="static"
    >
      <Modal.Body className="modal-body">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        />

        <div className="content-container">
          <h3 className="content-title-text" id="market-restricted-modal-title">
            {isReactivation
              ? "This Want-Listing is licensed to The Buyer Listing Service®"
              : "Posting in this market is licensed to The Buyer Listing Service®"}
          </h3>

          <p className="fs-6 content-description-text">
            Under our licensing agreement with the MLS or association that serves this market,
            Want-Listings here are posted by its licensed members in The Buyer
            Listing Service® and syndicated to {brand} for public visibility.
          </p>

          <div className="mb-4 mt-4">
            <p className="fs-6 ms-1 content-description-text">
              {" "}
              • The licence covers posting only — you can still search, browse
              and save Want-Listings in this market on {brand}.
            </p>
            <p className="fs-6 ms-1 content-description-text">
              {" "}
              • Licensed members of that organization post Want-Listings in The Buyer
              Listing Service®.
            </p>
            {isReactivation && (
              <p className="fs-6 ms-1 content-description-text">
                {" "}
                • {brand} Want-Listings created here before the agreement have
                been archived and cannot be re-activated.
              </p>
            )}
          </div>

          <p className="fs-6 content-description-text">
            {" "}
            If you’re a licensed agent, ask your MLS or association about access to The Buyer
            Listing Service®.{" "}
          </p>
        </div>

        <div className="modal-footer mt-20 p-0 d-flex" style={{ gap: 15 }}>
          <Button variant="secondary" onClick={handleLearnMoreNavigation}>
            Learn More
          </Button>
          <Button variant="primary" onClick={handleContactUsNavigation}>
            Contact Us
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MarketRestrictedModal;
